// namespace (소문자)
export const NAMESPACE = 'booking';
//actions
export const CREATE_BOOKING = 'CREATE_BOOKING';
export const FETCH_BOOKING = 'FETCH_BOOKING';
export const UPDATE_BOOKING = 'UPDATE_BOOKING';
export const DELETE_BOOKING = 'DELETE_BOOKING';
export const FETCH_BOOKING_LIST = 'FETCH_BOOKING_LIST';

//mutations
export const SET_BOOKING = 'SET_BOOKING';
export const SET_BOOKING_LIST = 'SET_BOOKING_LIST';

//state

//getters
export const BOOKING = 'BOOKING';
export const BOOKING_LIST = 'BOOKING_LIST';
